import Vue from 'vue'
import Router from 'vue-router'
import App from './App'
import Hello from './components/Hello'
import Contact from './components/Contact'
import Translation from './components/mixins/Translation.js'
import Resource from 'vue-resource'

/* eslint-disable no-new */
Vue.use(Router)
Vue.use(Resource)
Vue.mixin(Translation)

var router = new Router()

router.map({
  '/:lang': {
    name: 'hello',
    component: Hello
  },
  '/contact/:lang': {
    name: 'contact',
    component: Contact
  }
})

router.beforeEach(function () {
  window.scrollTo(0, 0)
})

router.redirect({
  '*': '/en'
})

router.start(App, 'app')



// WEBPACK FOOTER //
// ./src/main.js